import { homeConstants } from "../constants";
import { homeService } from "../services";
import { alertActions } from "./alertActions";

function getReportE_commerce() {
    return (dispatch) => {
        dispatch(request(homeConstants.GET_REPORT_E_COMMERCE_REQUEST));

        homeService.getReportE_commerce().then(
            (res) => {
                console.log("user into homeActions (getReportE_commerce)");

                if (res === undefined) {
                    dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
                    dispatch(failure(homeConstants.GET_REPORT_E_COMMERCE_FAILURE, "ارتباط با سرور برقرار نیست"));
                } else if (res.success) {
                    dispatch(success(homeConstants.GET_REPORT_E_COMMERCE_SUCCESS, res.data));
                } else if (res.success === false) {
                    dispatch(alertActions.error(res.message));
                    dispatch(failure(homeConstants.GET_REPORT_E_COMMERCE_FAILURE, res.message));
                }

                setTimeout(() => {
                    dispatch(alertActions.clear());
                }, 1500);
            },
            (error) => {
                console.log("error occurred");
                console.log(error.toString());
                dispatch(alertActions.error(error.toString()));
                dispatch(failure(homeConstants.GET_REPORT_E_COMMERCE_FAILURE, error.toString()));
            }
        );
    };
}


function getAllEmployerUserList() {
    return (dispatch) => {
        dispatch(request(homeConstants.GET_ALL_EMPLOYER_USER_LIST_REQUEST));

        homeService.getAllEmployerUserList().then(
            (res) => {
                console.log("user into homeActions (getAllEmployerUserList)");
                if (res === undefined) {

                    dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
                    dispatch(failure(homeConstants.GET_ALL_EMPLOYER_USER_LIST_FAILURE, "ارتباط با سرور برقرار نیست"));

                } else if (res.success) {

                    dispatch(success(homeConstants.GET_ALL_EMPLOYER_USER_LIST_SUCCESS, res.data));

                } else if (res.success === false) {

                    dispatch(alertActions.error(res.message));
                    dispatch(failure(homeConstants.GET_ALL_EMPLOYER_USER_LIST_FAILURE, res.message));

                }

                setTimeout(() => {
                    dispatch(alertActions.clear());
                }, 1500);
            },
            (error) => {
                console.log("error occurred");
                console.log(error.toString());
                dispatch(alertActions.error(error.toString()));
                dispatch(failure(homeConstants.GET_ALL_EMPLOYER_USER_LIST_FAILURE, error.toString()));
            }
        );
    };
}

const setSocket = (socket) => dispatch => dispatch({ type: homeConstants.SET_SOCKET, socket })

const clearSocket = () => dispatch => dispatch({ type: homeConstants.CLEAR_SOCKET })

const request = (type, data) => ({ type: type, data })

const success = (type, data) => ({ type: type, data })

const failure = (type, data) => ({ type: type, data })


export const homeActions = {
    getReportE_commerce,
    getAllEmployerUserList,
    setSocket,
    clearSocket
};